import { Badge } from '@/ux-common/components/badge/badge';
import { cn } from '@/ux-common/lib/utils';

interface SequenceActivityPillProps {
  /** Whether this sequence is currently active */
  isActive: boolean;
}

/**
 * Displays the active/inactive status of a sequence as a badge pill.
 * Used in sequencer section headers to indicate which sequence is currently running.
 *
 * @example
 * // Active sequence
 * <SequenceActivityPill isActive={true} />
 *
 * @example
 * // Inactive sequence
 * <SequenceActivityPill isActive={false} />
 */
export const SequenceActivityPill = ({ isActive }: SequenceActivityPillProps) => {
  return (
    <div className="flex items-center space-x-2">
      {isActive ? (
        <Badge className={cn('badge badge-brand')}>Active</Badge>
      ) : (
        <Badge className={cn('badge badge-default')}>Not Active</Badge>
      )}
    </div>
  );
};
